import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayParishFilter({
  setFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="parish"
      filters={filters}
      id="parish"
      label="Parish (civil / non-civil)"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HeritageGatewayParishFilter);
